import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'footings-excavation-for-homes';
const serviceId = 4
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Footings Excavation for Homes in Sydney | ${BUSINESS_NAME}`,
        description: "Precise footing excavation for home extensions and renovations, ensuring strong structural foundations.",
        keywords: "footings excavation sydney, home extensions, home renovations, structural foundations, site preparation, trenching services, residential excavation, commercial excavation, custom excavation solutions, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Footings Excavation for Homes',
    description: 'Precise footing excavation for home extensions and renovations, ensuring strong structural foundations.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
